import _toConsumableArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import React__default from 'react';
import { C as Colors, c as changeColorToClassName } from '../color-91e43dce.js';
var TextButton = function TextButton(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? Colors.ONBACKGROUND_1 : _ref$color,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$disableUnderline = _ref.disableUnderline,
    disableUnderline = _ref$disableUnderline === void 0 ? false : _ref$disableUnderline,
    _ref$onClick = _ref.onClick,
    _onClick = _ref$onClick === void 0 ? function () {/* noop */} : _ref$onClick,
    children = _ref.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: [].concat(_toConsumableArray(Array.isArray(className) ? className : [className]), [changeColorToClassName(color), disableUnderline ? 'sendbird-textbutton--not-underline' : 'sendbird-textbutton', disabled ? 'sendbird-textbutton--disabled' : '']).join(' '),
    role: "button",
    tabIndex: 0,
    onClick: function onClick(e) {
      return _onClick(e);
    },
    onKeyPress: function onKeyPress(e) {
      return _onClick(e);
    }
  }, children);
};
export { TextButton as default };